import { Colors, FlexBox,  FInter } from '@brg/ui';
import styled, { css } from "styled-components";
import { LayoutConst } from 'core/modules';
import { Input } from '@brg/input';
import {ImageWrapper} from "../../components/ResizedImageEnhanced/styles";

interface StudentProps {
    viewed?: boolean;
    status?:string;
    isActive?: boolean;
  }

export const CheckHomeworkWrapper = styled(FlexBox)`
    width: 1152px;
    flex-direction: column;
    @media (max-width:${LayoutConst.screen.l_12}px) {
        width: 940px;
    }
    @media (max-width: ${LayoutConst.screen.md}px) {
        width: calc(100% - 32px);
    }
`;

export const CheckHomeworkHead = styled.div`
    margin-bottom: 24px;
`;

export const CheckHomeworkContent = styled(FlexBox)`
    display: grid;
    grid-template-columns: 240px 1fr;
    gap: 24px;

    @media (max-width:${LayoutConst.screen.l_12}px) {
      display: flex;
      flex-flow: column;
    }
`;

export const CheckHomeworkTheme = styled(FInter.SectionTitleSubtitleBoldFlex)<{ isTeamEdit?: boolean, isTable?: boolean, isCheckbox?: boolean, fixedHeight?: boolean, nowrap?: boolean, isPresentationLMS?: boolean }>`

`;

export const CheckHomeworkSidebar = styled(FlexBox)`
    flex-direction: column;

    @media(max-width: ${LayoutConst.screen.l_12}px) {
      width: 50%;
    }

    
    @media(max-width: ${LayoutConst.screen.s - 1}px) {
      width: 100%;
    }
`;

export const CheckHomeworkСhoiceWork = styled(FlexBox)`
    width: 300px;

    .brg-input__control {
        background: transparent;
        outline: none!important;
        cursor: pointer;
        border: none;
        height: 32px!important;
        margin-bottom: 0;
        min-height: 32px!important;
        color: ${Colors.zel};
        align-content: center;
  
      .brg-input__placeholder{
            color: ${Colors.galBlack100};

            :hover{
              color: ${Colors.galBlack47};
            }
        }

      :hover .brg-input__placeholder {
        color: ${Colors.galBlack47};
      }

        .brg-input__single-value {
            font-size: 17px;
            line-height: 22px;
            font-weight: 700;
            color: ${Colors.galBlack100};
        }

        .brg-input__value-container{
            padding: 0;
            font-size: 17px;
            font-weight: 600;
            line-height: 22px;
            color:${Colors.galBlack100};
        }

        .brg-input__indicator {
            svg {
                path {
                    fill: ${Colors.galBlack100};
                  }
              }
        }
    }
  
   input {
     background: ${Colors.galBlack100}!important;
   }
  
   .text-input{
      height: 32px!important;
      border:none!important;
      color: ${Colors.galBlack100};
    }
  
    input::placeholder {
      color: ${Colors.galBlack100};
    }  
  
    .brg-input__menu{
      background: ${Colors.defaultGrey6};
      * {
      color: ${Colors.galBlack100};

       }
       svg {
        path {
          fill:${Colors.galBlack100};
        }
       }
    }
`;


export const CheckHomeworkInput = styled(FlexBox)`
    flex-direction: column;
    margin-bottom: 24px;
    width: 100%;
`;

export const CheckHomeworkMain = styled.div`
    display: grid;
    gap: 24px;
    height: 825px;
    overflow-y: auto;

    @media(max-width: 1280px ) {
      height: 100%;
      display: flex;
      flex-flow: column;
      width: 100%;
    }
`;

export const CheckHomeworkStudentsList = styled.ul`
    width:100%;
    display:flex;
    flex-direction: column;
    margin:0;
    padding:0;
`;

export const CheckHomeworkStudent = styled.li<StudentProps>`
    border-bottom: 1px solid ${Colors.galBlack10};
    height:28px;
    padding: 6px 8px;
    color: ${Colors.galBlack100};
    cursor: pointer;
    display: flex;
    align-items: center;

    ${({ status }) => (status === '' || status === null) && css`
      position: relative;

      &::before {
        content: '•';
        position: absolute;
        top: 50%;
        left: 8px;
        transform: translateY(-50%);
        display: block;
        color: #96AAC1;
      }
    `};

     ${({ isActive }) => isActive && css`
      background-color:${Colors.galBlack73} !important;
      color: #FFF;
     `};

    :hover{
        background-color:${Colors.galBlack73};
        color: #FFF;
    }

  ${({ viewed }) => viewed === true && `
    background-color: #e6ffe6; 
  `}

  ${({ status }) => {
    switch (status) {
      case 'fine':
        return `
          background-color: #29894E1A;
        `;
      case 'badly':
        return `
          background-color: #FD6C521A;
        `;
      default:
        return `
        background-color: transparent;
        `;
    }
  }}
`;

export const CheckHomeworkMarkerViewed = styled.div<StudentProps>`
    border-radius: 50%;
    background-color: ${Colors.generalDenimBlue};
    width: 6px;
    height: 6px;
    margin-right: 8px;
    opacity: ${({ viewed }) => (viewed === false ? '1' : '0')};
`;

export const CheckHomeworkSaveButton =  styled.button`
    width: 137px;
    height: 38px;
    border-radius: 3px;
    padding: 8px 24px;
    background-color: ${({disabled}) => disabled ? Colors.galBlack47 : Colors.galBlack100};
    color: ${({disabled}) => disabled ? Colors.geoWhite73 : Colors.geoWhite100};
    cursor: ${({disabled}) => disabled ? 'not-allowed' : 'pointer'};
    transition: all 0.2s;
    font-family: Inter;
    font-size: 17px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
    letter-spacing: -0.34px;
    border:none;
    justify-self: end;

    :hover{
      background-color: ${({disabled}) => disabled ? Colors.galBlack47 : '#1F1F1F'}!important;
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
      width: 100%;
      height: 46px;
      margin-bottom: 8px;
    }
`;

export const CheckHomeworkTitle = styled(FlexBox)`
    justify-content: space-between;
`;

export const CheckHomeworkAuthor = styled(FInter.SectionTitleSubtitleBoldFlex)<{ isTeamEdit?: boolean, isTable?: boolean, isCheckbox?: boolean, fixedHeight?: boolean, nowrap?: boolean, isPresentationLMS?: boolean }>`
@media(max-width: ${LayoutConst.screen.s - 1}px) {
  font-size: 22px;
  line-height: 28px;
}
`

export const CheckHomeworkNextButton = styled.button`
    width: 234px;
    height: 38px;
    border-radius: 3px;
    padding: 8px 24px;
    // background-color: ${({disabled}) => disabled ? Colors.galBlack100 : '#FFFFFF' };
    background-color:#FFFFFF;
    color: ${({disabled}) => disabled ?   Colors.galBlack47 : Colors.galBlack100 };
    cursor: ${({disabled}) => disabled ? 'not-allowed' : 'pointer'};
    transition: all 0.2s;
    font-family: Inter;
    font-size: 17px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
    etter-spacing: -0.34px;
    border:1px solid ${Colors.galBlack31};
    cursor:pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;

    :hover{
        border:1px solid ${Colors.galBlack100};
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px ) {
      width: 100%;
      height: 46px;
      justify-content: center;

      svg {
        margin-left: 12px;
      }
    }
`;

export const CheckHomeworkCurrentWork = styled.div`
    width: 100%;
    height: 600px;

    @media(max-width: 1280px ) {
      height: 481px;
    }

    @media(max-width: 420px ) {
      height: 216px;
    }
`;

export const CheckHomeworkReview = styled(FlexBox)`
    justify-content: space-between;

    @media(max-width: 1280px ) {
      width: 50%;
      flex-flow: column;
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px ) {
      width: 100%;
    }
`;

export const CheckHomeworkAccept = styled.div`
    width: 344px;
    height: 72px;
    margin-right: 24px;
    display: flex;
    color: ${Colors.galBlack73};
    justify-content: space-between;
    background-color: #F2F2F2;
    padding: 24px;
    align-items: center;
    font-family: Inter;
    font-size: 17px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
    // margin-right: 24px;

    .accept-work {
      white-space: nowrap;
      margin-right: 14px;
    }

    .accept-label {
      font-size: 13px;
      line-height: 16px;
    }

    @media(max-width: 1280px ) {
      width: 100%;
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px ) {
      flex-flow: column;
      justify-content: flex-start;
      align-items: flex-start;
      .accept-work {
        width: 100%;
        margin-bottom: 12px;
      }
    }
`;

export const CheckHomeworkRadioButton = styled(Input.Radio)`
    color: ${Colors.galBlack73};
    font-size: 13px;
    font-style: normal;
    font-weight: 700;
    background: transparent;
    line-height: 16px;

    border: 1px solid #909090;


    // input + div {
    //   background: red;

    // }

    // div[title="Да"]:first-of-type {
    //   background: red;
    // }
`;

export const CheckHomeworkСomment = styled.div`
    position: relative;
    background-color: #F2F2F2;

    @media(max-width: ${LayoutConst.screen.l_12}px) {
      width: 100%;
    }
`;

export const CheckHomeworkTextarea = styled.textarea`
    width: 100%;
    height: 72px;
    border:none!important;
    outline:none!important;
    padding: 12px 60px 12px 16px;
    resize: none;
    color: ${Colors.galBlack100};
    background-color: #F2F2F2;
    ::placeholder {
        color:#B6B6B5;
    }
  &::-webkit-scrollbar {
    width: 3px;
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.08);
  }
  &::-webkit-scrollbar-thumb {
    background: ${Colors.galBlack47};
  }
  &::-webkit-scrollbar-track {
    background: ${Colors.galBlack10};
  }

    @media(max-width: 1280px ) {
      width: 100%;
      height: 134px;
    }
`;

export const CheckHomeworkMaxTextLength = styled.div`
position: absolute;
bottom: 8px;
right: 16px;
font-family: Inter;
font-size: 10px;
font-style: normal;
font-weight: 500;
line-height: 13px;
color:${Colors.galBlack47};
`;

export const CheckHomeworkPictureIcon = styled.div`
    position: absolute;
    top: 8px;
    right: 16px;

  input {
    width: 100%;
    height: 100%;
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 999;
    cursor: pointer;
  }
`;

export const CommentImageList = styled(FlexBox)<{fullWidth?: boolean}>`
  flex-wrap: wrap;
  row-gap: 16px;
  column-gap: 16px;
  max-width: ${({fullWidth}) => fullWidth ? '100%' : '90%'};
  padding: ${({fullWidth}) => fullWidth ? '0' : '8px 16px'};
  
  svg {
    cursor: pointer;
  }
  
  ${ImageWrapper} {
    width: 100px;
    height: auto;
    align-items: flex-start;
    cursor: pointer;
  }
  
  img {
    height: max-content;
    max-width: 100px;
  }
`;
export const CommentImage = styled.img`
  cursor: pointer;
  max-width: 100px;
`;

export const LMSCheckHomeworkEditPageGridInput = styled(FlexBox)`

.brg-input__control {
  background-color: ${Colors.galBlack5}!important;
  outline: none!important;
  cursor: pointer;
  border: none;
  height: 32px!important;
  margin-bottom: 0;
  min-height: 32px!important;
  color: ${Colors.zel};
  align-content: center;

  .brg-input__placeholder{
      color: ${Colors.galBlack27};
      
    }

    .brg-input__placeholder:hover {
      color: ${Colors.galBlack47};
    }



    .brg-input__value-container{
      // background: ${Colors.galBlack5};
      // padding: 0;
      // font-size: 17px;
      // font-weight: 600;
      // line-height: 22px;
      // color:${Colors.galBlack100};
  }

  .brg-input__single-value {
  font-size: 13px;
  line-height: 16px;
  color: ${Colors.galBlack100};
  }

  :hover .brg-input__placeholder{
    color: ${Colors.galBlack47};
  }

}

input {
  background: ${Colors.galBlack5}!important;
  ::placeholder{
    color: ${Colors.galBlack27};
  }
}

input:hover {
  color:${Colors.galBlack47};
  ::placeholder {
    color: ${Colors.galBlack47};
  }  
}

.text-input{
  height: 32px!important;
  border:none!important;
  color: ${Colors.zel};

  :hover{
    color: ${Colors.galBlack47};
  }
}

.brg-input__indicator {
  svg {
      path {
          fill: ${Colors.zel};
        }
    }
}

.brg-input__menu{
  background: ${Colors.defaultGrey6};

  * {
  color: ${Colors.galBlack100};
   }

   svg {
    path {
      fill:${Colors.galBlack100};
    }
   }
}
`;

export const RecommendationWrapper = styled(FlexBox)`
  gap: 8px;
  color: var(--Gallllery-Black47, #909090);
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.3px;
  height: 100%;
`


export const RecommendationsList = styled.ol`
  padding-left: 1em;
`import { Colors, FlexBox,  FInter } from '@brg/ui';
import styled, { css } from "styled-components";
import { LayoutConst } from 'core/modules';
import { Input } from '@brg/input';
import {ImageWrapper} from "../../components/ResizedImageEnhanced/styles";

interface StudentProps {
    viewed?: boolean;
    status?:string;
    isActive?: boolean;
  }

export const CheckHomeworkWrapper = styled(FlexBox)`
    width: 1152px;
    flex-direction: column;
    @media (max-width:${LayoutConst.screen.l_12}px) {
        width: 940px;
    }
    @media (max-width: ${LayoutConst.screen.md}px) {
        width: calc(100% - 32px);
    }
`;

export const CheckHomeworkHead = styled.div`
    margin-bottom: 24px;
`;

export const CheckHomeworkContent = styled(FlexBox)`
    display: grid;
    grid-template-columns: 240px 1fr;
    gap: 24px;

    @media (max-width:${LayoutConst.screen.l_12}px) {
      display: flex;
      flex-flow: column;
    }
`;

export const CheckHomeworkTheme = styled(FInter.SectionTitleSubtitleBoldFlex)<{ isTeamEdit?: boolean, isTable?: boolean, isCheckbox?: boolean, fixedHeight?: boolean, nowrap?: boolean, isPresentationLMS?: boolean }>`

`;

export const CheckHomeworkSidebar = styled(FlexBox)`
    flex-direction: column;

    @media(max-width: ${LayoutConst.screen.l_12}px) {
      width: 50%;
    }

    
    @media(max-width: ${LayoutConst.screen.s - 1}px) {
      width: 100%;
    }
`;

export const CheckHomeworkСhoiceWork = styled(FlexBox)`
    width: 300px;

    .brg-input__control {
        background: transparent;
        outline: none!important;
        cursor: pointer;
        border: none;
        height: 32px!important;
        margin-bottom: 0;
        min-height: 32px!important;
        color: ${Colors.zel};
        align-content: center;
  
      .brg-input__placeholder{
            color: ${Colors.galBlack100};

            :hover{
              color: ${Colors.galBlack47};
            }
        }

      :hover .brg-input__placeholder {
        color: ${Colors.galBlack47};
      }

        .brg-input__single-value {
            font-size: 17px;
            line-height: 22px;
            font-weight: 700;
            color: ${Colors.galBlack100};
        }

        .brg-input__value-container{
            padding: 0;
            font-size: 17px;
            font-weight: 600;
            line-height: 22px;
            color:${Colors.galBlack100};
        }

        .brg-input__indicator {
            svg {
                path {
                    fill: ${Colors.galBlack100};
                  }
              }
        }
    }
  
   input {
     background: ${Colors.galBlack100}!important;
   }
  
   .text-input{
      height: 32px!important;
      border:none!important;
      color: ${Colors.galBlack100};
    }
  
    input::placeholder {
      color: ${Colors.galBlack100};
    }  
  
    .brg-input__menu{
      background: ${Colors.defaultGrey6};
      * {
      color: ${Colors.galBlack100};

       }
       svg {
        path {
          fill:${Colors.galBlack100};
        }
       }
    }
`;


export const CheckHomeworkInput = styled(FlexBox)`
    flex-direction: column;
    margin-bottom: 24px;
    width: 100%;
`;

export const CheckHomeworkMain = styled.div`
    display: grid;
    gap: 24px;
    height: 825px;
    overflow-y: auto;

    @media(max-width: 1280px ) {
      height: 100%;
      display: flex;
      flex-flow: column;
      width: 100%;
    }
`;

export const CheckHomeworkStudentsList = styled.ul`
    width:100%;
    display:flex;
    flex-direction: column;
    margin:0;
    padding:0;
`;

export const CheckHomeworkStudent = styled.li<StudentProps>`
    border-bottom: 1px solid ${Colors.galBlack10};
    height:28px;
    padding: 6px 8px;
    color: ${Colors.galBlack100};
    cursor: pointer;
    display: flex;
    align-items: center;

    ${({ status }) => (status === '' || status === null) && css`
      position: relative;

      &::before {
        content: '•';
        position: absolute;
        top: 50%;
        left: 8px;
        transform: translateY(-50%);
        display: block;
        color: #96AAC1;
      }
    `};

     ${({ isActive }) => isActive && css`
      background-color:${Colors.galBlack73} !important;
      color: #FFF;
     `};

    :hover{
        background-color:${Colors.galBlack73};
        color: #FFF;
    }

  ${({ viewed }) => viewed === true && `
    background-color: #e6ffe6; 
  `}

  ${({ status }) => {
    switch (status) {
      case 'fine':
        return `
          background-color: #29894E1A;
        `;
      case 'badly':
        return `
          background-color: #FD6C521A;
        `;
      default:
        return `
        background-color: transparent;
        `;
    }
  }}
`;

export const CheckHomeworkMarkerViewed = styled.div<StudentProps>`
    border-radius: 50%;
    background-color: ${Colors.generalDenimBlue};
    width: 6px;
    height: 6px;
    margin-right: 8px;
    opacity: ${({ viewed }) => (viewed === false ? '1' : '0')};
`;

export const CheckHomeworkSaveButton =  styled.button`
    width: 137px;
    height: 38px;
    border-radius: 3px;
    padding: 8px 24px;
    background-color: ${({disabled}) => disabled ? Colors.galBlack47 : Colors.galBlack100};
    color: ${({disabled}) => disabled ? Colors.geoWhite73 : Colors.geoWhite100};
    cursor: ${({disabled}) => disabled ? 'not-allowed' : 'pointer'};
    transition: all 0.2s;
    font-family: Inter;
    font-size: 17px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
    letter-spacing: -0.34px;
    border:none;
    justify-self: end;

    :hover{
      background-color: ${({disabled}) => disabled ? Colors.galBlack47 : '#1F1F1F'}!important;
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
      width: 100%;
      height: 46px;
      margin-bottom: 8px;
    }
`;

export const CheckHomeworkTitle = styled(FlexBox)`
    justify-content: space-between;
`;

export const CheckHomeworkAuthor = styled(FInter.SectionTitleSubtitleBoldFlex)<{ isTeamEdit?: boolean, isTable?: boolean, isCheckbox?: boolean, fixedHeight?: boolean, nowrap?: boolean, isPresentationLMS?: boolean }>`
@media(max-width: ${LayoutConst.screen.s - 1}px) {
  font-size: 22px;
  line-height: 28px;
}
`

export const CheckHomeworkNextButton = styled.button`
    width: 234px;
    height: 38px;
    border-radius: 3px;
    padding: 8px 24px;
    // background-color: ${({disabled}) => disabled ? Colors.galBlack100 : '#FFFFFF' };
    background-color:#FFFFFF;
    color: ${({disabled}) => disabled ?   Colors.galBlack47 : Colors.galBlack100 };
    cursor: ${({disabled}) => disabled ? 'not-allowed' : 'pointer'};
    transition: all 0.2s;
    font-family: Inter;
    font-size: 17px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
    etter-spacing: -0.34px;
    border:1px solid ${Colors.galBlack31};
    cursor:pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;

    :hover{
        border:1px solid ${Colors.galBlack100};
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px ) {
      width: 100%;
      height: 46px;
      justify-content: center;

      svg {
        margin-left: 12px;
      }
    }
`;

export const CheckHomeworkCurrentWork = styled.div`
    width: 100%;
    height: 600px;

    @media(max-width: 1280px ) {
      height: 481px;
    }

    @media(max-width: 420px ) {
      height: 216px;
    }
`;

export const CheckHomeworkReview = styled(FlexBox)`
    justify-content: space-between;

    @media(max-width: 1280px ) {
      width: 50%;
      flex-flow: column;
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px ) {
      width: 100%;
    }
`;

export const CheckHomeworkAccept = styled.div`
    width: 344px;
    height: 72px;
    margin-right: 24px;
    display: flex;
    color: ${Colors.galBlack73};
    justify-content: space-between;
    background-color: #F2F2F2;
    padding: 24px;
    align-items: center;
    font-family: Inter;
    font-size: 17px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
    // margin-right: 24px;

    .accept-work {
      white-space: nowrap;
      margin-right: 14px;
    }

    .accept-label {
      font-size: 13px;
      line-height: 16px;
    }

    @media(max-width: 1280px ) {
      width: 100%;
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px ) {
      flex-flow: column;
      justify-content: flex-start;
      align-items: flex-start;
      .accept-work {
        width: 100%;
        margin-bottom: 12px;
      }
    }
`;

export const CheckHomeworkRadioButton = styled(Input.Radio)`
    color: ${Colors.galBlack73};
    font-size: 13px;
    font-style: normal;
    font-weight: 700;
    background: transparent;
    line-height: 16px;

    border: 1px solid #909090;


    // input + div {
    //   background: red;

    // }

    // div[title="Да"]:first-of-type {
    //   background: red;
    // }
`;

export const CheckHomeworkСomment = styled.div`
    position: relative;
    background-color: #F2F2F2;

    @media(max-width: ${LayoutConst.screen.l_12}px) {
      width: 100%;
    }
`;

export const CheckHomeworkTextarea = styled.textarea`
    width: 100%;
    height: 72px;
    border:none!important;
    outline:none!important;
    padding: 12px 60px 12px 16px;
    resize: none;
    color: ${Colors.galBlack100};
    background-color: #F2F2F2;
    ::placeholder {
        color:#B6B6B5;
    }
  &::-webkit-scrollbar {
    width: 3px;
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.08);
  }
  &::-webkit-scrollbar-thumb {
    background: ${Colors.galBlack47};
  }
  &::-webkit-scrollbar-track {
    background: ${Colors.galBlack10};
  }

    @media(max-width: 1280px ) {
      width: 100%;
      height: 134px;
    }
`;

export const CheckHomeworkMaxTextLength = styled.div`
position: absolute;
bottom: 8px;
right: 16px;
font-family: Inter;
font-size: 10px;
font-style: normal;
font-weight: 500;
line-height: 13px;
color:${Colors.galBlack47};
`;

export const CheckHomeworkPictureIcon = styled.div`
    position: absolute;
    top: 8px;
    right: 16px;

  input {
    width: 100%;
    height: 100%;
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 999;
    cursor: pointer;
  }
`;

export const CommentImageList = styled(FlexBox)<{fullWidth?: boolean}>`
  flex-wrap: wrap;
  row-gap: 16px;
  column-gap: 16px;
  max-width: ${({fullWidth}) => fullWidth ? '100%' : '90%'};
  padding: ${({fullWidth}) => fullWidth ? '0' : '8px 16px'};
  
  svg {
    cursor: pointer;
  }
  
  ${ImageWrapper} {
    width: 100px;
    height: auto;
    align-items: flex-start;
    cursor: pointer;
  }
  
  img {
    height: max-content;
    max-width: 100px;
  }
`;
export const CommentImage = styled.img`
  cursor: pointer;
  max-width: 100px;
`;

export const LMSCheckHomeworkEditPageGridInput = styled(FlexBox)`

.brg-input__control {
  background-color: ${Colors.galBlack5}!important;
  outline: none!important;
  cursor: pointer;
  border: none;
  height: 32px!important;
  margin-bottom: 0;
  min-height: 32px!important;
  color: ${Colors.zel};
  align-content: center;

  .brg-input__placeholder{
      color: ${Colors.galBlack27};
      
    }

    .brg-input__placeholder:hover {
      color: ${Colors.galBlack47};
    }



    .brg-input__value-container{
      // background: ${Colors.galBlack5};
      // padding: 0;
      // font-size: 17px;
      // font-weight: 600;
      // line-height: 22px;
      // color:${Colors.galBlack100};
  }

  .brg-input__single-value {
  font-size: 13px;
  line-height: 16px;
  color: ${Colors.galBlack100};
  }

  :hover .brg-input__placeholder{
    color: ${Colors.galBlack47};
  }

}

input {
  background: ${Colors.galBlack5}!important;
  ::placeholder{
    color: ${Colors.galBlack27};
  }
}

input:hover {
  color:${Colors.galBlack47};
  ::placeholder {
    color: ${Colors.galBlack47};
  }  
}

.text-input{
  height: 32px!important;
  border:none!important;
  color: ${Colors.zel};

  :hover{
    color: ${Colors.galBlack47};
  }
}

.brg-input__indicator {
  svg {
      path {
          fill: ${Colors.zel};
        }
    }
}

.brg-input__menu{
  background: ${Colors.defaultGrey6};

  * {
  color: ${Colors.galBlack100};
   }

   svg {
    path {
      fill:${Colors.galBlack100};
    }
   }
}
`;

export const RecommendationWrapper = styled(FlexBox)`
  gap: 8px;
  color: var(--Gallllery-Black47, #909090);
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.3px;
  height: 100%;
`


export const RecommendationsList = styled.ol`
  padding-left: 1em;
`